import styled from 'styled-components';

export const Container = styled.div`
  label {
    font-family: arial;
    display: block;
    position: relative;
    padding-left: 30px;
    margin-bottom: 5px;
    padding-top: 3px;
    cursor: pointer;
    font-size: 16px;

    input {
      position: absolute;
      z-index: -1;
      opacity: 0;
    }

    span {
      width: 120px;
      height: 34px;
      margin-left: 8px;

      font-style: normal;
      font-weight: normal;
      font-size: 18px;
      line-height: 34px;
      letter-spacing: -0.33px;
      color: #032d23;
    }

    input:checked ~ .control_indicator {
      background: var(--purple);
    }

    input:checked ~ .control_indicator:after {
      display: block;
    }

    .control_indicator {
      position: absolute;
      top: 9px;
      left: 0;
      height: 20px;
      width: 20px;
      background: #e6e6e6;
      border: 0px solid #000000;
      border-radius: 0px;

      &:after {
        box-sizing: unset;
        content: '';
        position: absolute;
        display: none;
      }
    }

    &:hover {
      input ~ .control-indicator {
        background: red;
      }

      input:not([disabled]):checked ~ .control_indicator,
      input:checked:focus ~ .control_indicator {
        background: var(--purple);
      }
    }

    input:disabled ~ .control_indicator {
      background: #e6e6e6;
      opacity: 0.6;
      pointer-events: none;
    }
  }

  .control-checkbox {
    .control_indicator:after {
      left: 8px;
      top: 4px;
      width: 3px;
      height: 8px;
      border: solid #ffffff;
      border-width: 0 2px 2px 0;
      transform: rotate(45deg);
    }

    input:disabled ~ .control_indicator:after {
      border-color: #7b7b7b;
    }

    .control_indicator::before {
      content: '';
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      width: 4.5rem;
      height: 4.5rem;
      margin-left: -1.3rem;
      margin-top: -1.3rem;
      background: #2aa1c0;
      border-radius: 3rem;
      opacity: 0.6;
      z-index: 99999;
      transform: scale(0);
    }
  }
`;
